var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { clearable: "", placeholder: "状态" },
                  model: {
                    value: _vm.paramsData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "status", $$v)
                    },
                    expression: "paramsData.status"
                  }
                },
                _vm._l(_vm.statusList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addTrain.init()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "title", label: "训练标题" }
          }),
          _c("el-table-column", {
            attrs: { prop: "duration", label: "训练时长" }
          }),
          _c("el-table-column", {
            attrs: { prop: "training_time", label: "训练开始时间" }
          }),
          _c("el-table-column", {
            attrs: { label: "是否强制参加" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.is_mandatory == 1
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v("否")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "content_text", label: "训练内容" }
          }),
          _c("el-table-column", { attrs: { prop: "note", label: "备注信息" } }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0 ? _c("span", [_vm._v("未开始")]) : _vm._e(),
                    row.status == 1 ? _c("span", [_vm._v("进行中")]) : _vm._e(),
                    row.status == 2 ? _c("span", [_vm._v("已结束")]) : _vm._e(),
                    row.status == 3 ? _c("span", [_vm._v("已取消")]) : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "已报名学生列表" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "viewColor",
                        on: {
                          click: function($event) {
                            return _vm.$refs.SignUpStudentList.init(
                              row.training_plan_id
                            )
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "200",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      scope.row.status == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.addTrain.init(scope.row)
                                }
                              }
                            },
                            [_vm._v(" 修改 ")]
                          )
                        : _vm._e(),
                      scope.row.status == 0
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      scope.row.status == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleCancle(
                                    scope.row.training_plan_id
                                  )
                                }
                              }
                            },
                            [_vm._v(" 取消 ")]
                          )
                        : _vm._e(),
                      scope.row.status == 0
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      scope.row.status == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(
                                    scope.row.training_plan_id
                                  )
                                }
                              }
                            },
                            [_vm._v(" 删除 ")]
                          )
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": 10
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addTrain", {
        ref: "addTrain",
        attrs: { teamId: _vm.teamId },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("sign-up-student-list", { ref: "SignUpStudentList" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }